import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion, getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";


class PhDTheses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            tesis: props.tesis,
            currentPagetesis: 1,
            loadingtesis: true,
            tesisActuales: [],
            itemPerPage: props.item,
            vacia: false

        };
        if (this.state.tesis.length <= 0) {
            this.state.vacia = true;
        }
    }
    render() {
        const windowWidth = window.innerWidth;
		const isDesktop = windowWidth > 600;
        return (
            <div>
                <div>

                    {this.state.vacia ? <h1>There are no PhD theses to show</h1> : ''}
                    {this.setState({ tesisActuales: this.state.tesis.slice((this.state.currentPagetesis - 1) * this.state.itemPerPage, this.state.currentPagetesis * this.state.itemPerPage), loadingtesis: false })}

                    {this.state.loadingtesis & !this.state.vacia ? <Spinner /> :
                        this.state.tesisActuales.map((
                            { title, author, directors, readingDate, subjects,
                                college, department, registerID, teseo }) => {
                            return (
                                <div className='tesis-card' >
                                    <div className="description" on>
                                        <h1><b>{title}</b></h1>
                                        <table>
                                            <tr>
                                                <b>Author: </b>{author}
                                            </tr>
                                            <tr>{/* multiples directores DOI tiene otro identificador */}
                                                <b>Supervisor{directors.length > 1 ? 's' : ''}:</b><br />
                                                {directors.map((director, currentValue) => { return (<text>&nbsp;&nbsp;&nbsp;&nbsp;{director}{currentValue < directors.length - 1 ? <br /> : ''}</text>) })}
                                            </tr>
                                            {this.state.id === 'tesisFinished' ?
                                                <tr>
                                                    <b>Viva: </b>{readingDate}
                                                </tr>
                                                : ''}
                                            {subjects.length <= 0 ? '' :
                                                <tr>
                                                    <b>Topics: </b>{subjects.map((materia, currentValue) => { return (<text>{materia}{currentValue < subjects.length - 1 ? ', ' : ''}</text>) })}
                                                </tr>
                                            }
                                            <tr>
                                                <b>School/Faculty: </b>{college}</tr>
                                            <tr>
                                                <b>Department: </b>{department}</tr>
                                            {this.state.id === 'tesisFinished' ?
                                                <tr>
                                                    <b>Registry ID: </b><a href={'https://oa.upm.es/' + registerID} target="_blank" rel="noopener noreferrer">{registerID}</a>
                                                </tr>
                                                : ''}
                                            {this.state.id === 'tesisFinished' ?
                                                <tr>
                                                    <b>DOI: </b><a href={'https://doi.org/10.20868/UPM.thesis.' + registerID} target="_blank" rel="noopener noreferrer">{'10.20868/UPM.thesis.' + registerID}</a>
                                                </tr>
                                                : ''}
                                            {this.state.id === 'tesisFinished' ?
                                                <tr>
                                                    <b>TESEO: </b>{teseo ? <a href={teseo} target="_blank" rel="noopener noreferrer">{teseo}</a> : 'No disponible'}
                                                </tr>
                                                : ''}
                                        </table>
                                    </div>
                                    {isDesktop ?
                                    <div className="imagenes">
                                        <a href={'https://oa.upm.es/' + registerID} target="_blank" rel="noopener noreferrer"><img src="assets\img\logos\archivoDigitalUPM-logo.png" height='10px'  alt='Imagen del proyecto' /></a>
                                    </div>:null}
                                </div>
                            );

                        })}
                </div>
                <Paginacion id={this.state.id} itemPerPage={this.state.itemPerPage} length={this.state.tesis.length} />
                {this.setState({ currentPagetesis: getCurrentPage(this.state.id) })}
            </div>
        );

    }
}

export default PhDTheses;